import { FC } from "react";
import { Typography } from "@mui/material";
import __ from "src/utils/Translations";

type SyncStatus = "error" | "success";

interface StatusChipProps {
  variant: SyncStatus;
}

const variants = {
  error: {
    labelUT: "Błąd",
    bgcolor: "red.50",
    color: "red.800",
    borderColor: "red.200",
  },
  success: {
    labelUT: "Poprawne",
    bgcolor: "green.50",
    color: "green.900",
    borderColor: "green.500",
  },
};

export const StatusChip: FC<StatusChipProps> = ({ variant }) => {
  const current = variants[variant];

  return (
    <Typography
      sx={{
        display: "inline-flex",
        alignItems: "center",
        width: "max-content",
        backgroundColor: current.bgcolor,
        fontSize: "0.625rem",
        fontWeight: 800,
        color: current.color,
        textTransform: "uppercase",
        letterSpacing: "0.5px",
        padding: "0.25rem 0.5rem",
        border: "1px solid",
        borderColor: current.borderColor,
        borderRadius: "0.25rem",
      }}
      component="span"
    >
      {__(current.labelUT)}
    </Typography>
  );
};
